export default __webpack_public_path__ + "static/media/partners2.2d777029.png";